/* Built In Imports */
import { useEffect, useState } from 'react';

/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import Loader from '@components/Utility/Loader';

/* Services */

/**
 * Renders the Delayed component
 * @param {Object} children - Child Elements
 * @param {string} waitBeforeShow - wait time
 * @returns {ReactElement} Delayed for children component
 */
const Delayed = ({ children, waitBeforeShow = 500, waitMsg = 'Loading...' }) => {
  const [isShown, setIsShown] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsShown(true);
    }, waitBeforeShow);
    return () => clearTimeout(timer);
  }, [waitBeforeShow]);

  return isShown ? children : (
    <Box
      m="40px auto"
      textAlign="center"
    >
      <Loader pos="relative" />
      <Box
        fontFamily="'FedraSansStd-medium', sans-serif"
        m="20px"
      >
        {waitMsg}
      </Box>
    </Box>
  );
};

export default Delayed;
